import React from 'react';
import { Dialog, DialogContent, Typography, Box, Button, DialogActions } from '@mui/material';
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import Heading from '../../Components/Heading/heading.tsx';

interface PreviewFileModalProps {
    open: boolean;
    onClose: () => void;
    onConfirm: () => void;
    fileName?: string;
    previewData: any[];
    previewColumns: GridColDef[];
}

const PreviewFileModal: React.FC<PreviewFileModalProps> = ({
    open,
    onClose,
    onConfirm,
    fileName,
    previewData,
    previewColumns
}) => {
    return (
        <Dialog open={open} onClose={onClose}>
            <Box sx={{ marginLeft: { xs: '0px', sm: '-180px' }}}>
                <Heading title="Preview File Data" closeIcon="true" onClose={onClose} />
            </Box>
            <DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
                    <Typography variant="body2" sx={{ fontSize: '18px' }}>
                        <strong>File:</strong> {fileName || 'Unknown'} 
                    </Typography>
                    <Typography variant="body2" sx={{marginLeft: '10px', fontSize: '18px' }}>
                        <strong>Total Records:</strong> {previewData.length}
                    </Typography>
                </Box>

                <Box sx={{ height: 400, width: '100%', backgroundColor: '#fff' }}>
                    <DataGrid
                        rows={previewData}
                        columns={previewColumns}
                        disableRowSelectionOnClick
                        hideFooter 
                        sx={{
                            '& .MuiDataGrid-columnHeaders': {
                                backgroundColor: '#f5f5f5',
                                fontWeight: 'bold'
                            }
                        }}
                    />
                </Box>

                <DialogActions style={{ display: 'flex', justifyContent: 'center' }}>
                    <Button 
                        variant="outlined" 
                        color="inherit" 
                        onClick={onClose}
                        sx={{ height: '40px', minWidth: '100px', borderRadius: '4px' }}
                    >
                        Cancel
                    </Button>
                    <Button 
                        variant="contained" 
                        className="custom-button" 
                        onClick={onConfirm}
                        sx={{ height: '40px', minWidth: '100px', borderRadius: '4px' }}
                    >
                        Submit
                    </Button>
                </DialogActions>
            </DialogContent>
        </Dialog>
    );
};

export default PreviewFileModal;